import { FC } from 'react';

import { useSnapQuery } from '@features/spark-snaps/queries';

import IconButton from '@components/buttons/IconButton';
import { Edit as EditIcon, Snaps } from '@components/icons';
import ClickableArea from '@components/layout/ClickableArea';
import Skeleton from '@components/layout/Skeleton';
import Tooltip from '@components/layout/Tooltip';

import SparkSnapIcon from '../SparkSnapIcon';

import './SparkSnapItem.scss';

interface SparkSnapItemProps {
    accountId: string;
    snapId: number;
    onEdit?: (snapId: number) => void;
    canEdit?: boolean;
    onView: (snapId: number) => void;
}

const SparkSnapItem: FC<SparkSnapItemProps> = ({
    accountId,
    snapId,
    onEdit,
    canEdit = false,
    onView,
}) => {
    const { snapIsReady, snap, snapThumbnail } = useSnapQuery({
        accountId,
        snapId,
    });

    if (!snapIsReady) {
        return (
            <div className="spark-snap-item">
                <Skeleton className="skeleton-icon" height={64} width={64} />
            </div>
        );
    }

    if (!snap) {
        return <></>;
    }

    return (
        <div className="spark-snap-item">
            <ClickableArea
                data-testid={`view-snap-button_${snapId}`}
                onClick={() => onView(snapId)}
            >
                {snapThumbnail ? (
                    <SparkSnapIcon imgUrl={snapThumbnail} title={snap?.name} />
                ) : (
                    <div className="spark-snap-icon">
                        <div className="snap-fallback">
                            <div>
                                <Snaps />
                            </div>
                        </div>
                    </div>
                )}
            </ClickableArea>
            <div className="spark-snap-item_label">
                <Tooltip title={snap?.name}>
                    <span>{snap?.name}</span>
                </Tooltip>
                {canEdit && onEdit && (
                    <IconButton
                        data-testid={`edit-snap-button_${snapId}`}
                        onClick={() => onEdit(snapId)}
                        className="spark-snap-item_edit-button"
                    >
                        <EditIcon />
                    </IconButton>
                )}
            </div>
        </div>
    );
};

export default SparkSnapItem;
